import {PostType} from "../constants.ts";

const queryKeys = {
    profile:                    (user_uid: string, filters: any = null) => ['profile', user_uid, filters],
    profiles__all:              () => ['profile'],
    profile_subscriptions:      () => ['profile', 'subscriptions'],
    leagues:                    (user_uid?: string | any) => ['leagues', user_uid],
    league:                     (league_uid?: string | any) => ['league', league_uid],
    leagues_teams:              (league_uid?: string | any) => ['leagues-teams', ...(league_uid ? [league_uid] : [])],
    leagues_players:            (league_uid?: string | any) => ['leagues-players', ...(league_uid ? [league_uid] : [])],
    leagues_players_unassigned: (league_uid?: string | any) => ['leagues-players-unassigned', ...(league_uid ? [league_uid] : [])],
    leagues_applications:       (league_uid?: string | any) => ['leagues-applications', ...(league_uid ? [league_uid] : [])],
    leagues_stats:              (league_uid?: string | any, monthKey?: string) => ['leagues-stats', ...(league_uid ? [league_uid, monthKey] : [])],
    leagues_ranking:            (league_uid?: string | any, sortDescriptor?: any) => ['leagues-stats', ...(league_uid ? [league_uid] : ['']), ...(sortDescriptor ? [sortDescriptor] : [])],
    league__games_get:          (league_uid: string | any, gamesFilter?: any) => ['league', league_uid, 'games', ...(gamesFilter ? [gamesFilter] : [])],
    league_participants:        (league_uid?: string | any) => ['league-participants', ...(league_uid ? [league_uid] : [])],

    americanos:              () => ['americanos'],
    americano:               (americano_uid?: string | any) => ['americano', ...(americano_uid ? [americano_uid] : [])],
    americano_leaderboard:   (americano_uid?: string | any) => ['americano', americano_uid, 'leaderboard'],
    americano_current_round: (americano_uid?: string | any) => ['americano', americano_uid, 'current-round'],
    americano_round_games:   (americano_uid?: string | any, round?: number) => ['americano', americano_uid, 'round-games', ...(round ? [round] : [])],
    americano_player_stats:  (americano_uid?: string | any, player_uid?: string) => ['americano', americano_uid, 'player-stats', player_uid],
    mexicanos:               () => ['mexicanos'],
    mexicano:                (mexicano_uid?: string | any) => ['mexicano', ...(mexicano_uid ? [mexicano_uid] : [])],
    mexicano_leaderboard:    (mexicano_uid?: string | any) => ['mexicano', mexicano_uid, 'leaderboard'],
    mexicano_current_round:  (mexicano_uid?: string | any) => ['mexicano', mexicano_uid, 'current-round'],
    mexicano_round_games:    (mexicano_uid?: string | any, round?: number) => ['mexicano', mexicano_uid, 'round-games', ...(round ? [round] : [])],
    mexicano_player_stats:   (mexicano_uid?: string | any, player_uid?: string) => ['mexicano', mexicano_uid, 'player-stats', player_uid],

    kotcs:                   () => ['kotcs'],
    kotc:                    (kotc_uid?: string | any) => ['kotc', ...(kotc_uid ? [kotc_uid] : [])],
    kotc_leaderboard:        (kotc_uid?: string | any) => ['kotc', kotc_uid, 'leaderboard'],
    kotc_current_round:      (kotc_uid?: string | any) => ['kotc', kotc_uid, 'current-round'],
    kotc_round_games:        (kotc_uid?: string | any, round?: number) => ['kotc', kotc_uid, 'round-games', ...(round ? [round] : [])],

    tournament:                    (tournament_uid?: string | any) => ['tournament', ...(tournament_uid ? [tournament_uid] : [])], // TODO: include user_uid in queryKey
    tournaments:                   (user_uid?: string | any) => ['tournaments', user_uid],
    tournament_applications:       (tournament_uid: string | any) => ['tournament', tournament_uid, 'applications'],
    tournament_teams:              (tournament_uid: string | any) => ['tournament', tournament_uid, 'teams'],
    tournament_stages:             (tournament_uid: string | any) => ['tournament', tournament_uid, 'stages'],
    tournament_games:              (tournament_uid: string | any) => ['tournament', tournament_uid, 'games'],
    tournament_players:            (tournament_uid: string | any) => ['tournament', tournament_uid, 'players'],
    tournament_players_unassigned: (tournament_uid: string | any) => ['tournament', tournament_uid, 'players-unassigned'],
    tournament_ranking:            () => ['tournament', 'ranking'],
    tournament_ranking_groups:     () => ['ranking_groups'],
    tournament_ranking_group:      (ranking_group_uid: string | any) => ['ranking_groups', ranking_group_uid],
    courts:                        (params?: { club_uid: string }) => ['courts', ...(params ? [params] : [])],
    court:                         (court_uid: string | any) => ['courts', court_uid],

    booking: {
        getAvailableCourts:    (params?: { club_uid: string, startDate: any, includePrivate?: boolean }) => ['booking', 'getAvailableCourts', ...(params ? [params] : [])],
        getBookings:           (params?: { upcoming?: boolean, club_uid?: string }) => ['booking', 'getBookings', ...(params ? [params] : [])],
        getMonthlyAvailability: (params: { club_uid: string, year: number, month: number }) => ['booking', 'getMonthlyAvailability', params],
    },

    reviews: (params?: any) => ['reviews', ...(params ? [params] : [])],

    running: {
        getResults:            (uid?: string) => ['running', 'results', ...(uid ? [uid] : [])],
        getLeaderboardResults: (params?: any) => ['running', 'leaderboardResults', params || {}],
        getRankings:           (uid?: string) => ['running', 'rankings', ...(uid ? [uid] : [])],
        getImports:            () => ['running', 'imports'],
    },

    firebase: {
        messages: (uid?: string) => ['firebase', 'messages', ...(uid ? [uid] : [])],
    },

    admin: {
        transactions: () => ['admin', 'transactions'],
    },

    audits:       () => ['audits'],
    transactions: () => ['transactions'],
    products:     () => ['products'],

    club_applications: (club_uid: string | any) => ['club', club_uid, 'applications'],
    club_players_roster: (club_uid?: string) => ['club-players-roster', club_uid],

    posts:       () => ['posts'],
    posts__type: (type: typeof PostType[keyof typeof PostType]) => ['posts', type],
    post_find:   (post_slug: string) => ['posts', post_slug],

    market__all:    () => ['market'],
    market:         (category: string, location: object) => ['market', category, location],
    marketMyGames:  () => ['market', 'my-games'],

    players:       () => ['players'],
    players_merge: (source, target) => ['players', 'merge', {source, target}],
    player:        (uid?: string) => ['players', uid],
    player_stats:  (sortDescriptor?: any) => ['player-stats', ...(sortDescriptor ? [sortDescriptor] : [])],

    assessments:            (uid?: string) => ['assessments', ...(uid ? [uid] : [])],
    conversations:          (uid?: string) => ['conversations', ...(uid ? [uid] : [])],
    conversations_messages: (uid: string) => ['conversations', uid, 'messages'],
    coaches:                (uid?: string) => ['coaches', ...(uid ? [uid] : [])],

    aiInsights:           (uid?: string) => ['ai-insights', ...(uid ? [uid] : [])],
    aiInsightsResult:     (league_uid: string, ai_insight_uid: string) => ['ai-insight-result', league_uid, ai_insight_uid],
    aiInsightsTestResult: (ai_insight_uid: string, league_uid?: string) => ['ai-insight-test-result', ai_insight_uid, league_uid],
    gameProbability:      (game_uid: string) => ['game-probability', game_uid],

    ryder_cups:           () => ['ryder-cups'],
    ryder_cup:            (uid?: string) => ['ryder-cups', uid],
    ryder_cup_roster:     (uid?: string) => ['ryder-cups', uid, 'roster'],
    ryder_cup_rounds:     (uid?: string) => ['ryder-cups', uid, 'rounds'],
    ryder_cup_dashboard:  (uid?: string) => ['ryder-cups', uid, 'dashboard'],
    ryder_cup_matches:    (uid?: string) => ['ryder-cups', uid, 'matches'],

    clash_of_teams:           () => ['clash-of-teams'],
    clash_of_teams_one:       (uid?: string) => ['clash-of-teams', uid],
    clash_of_teams_dashboard: (uid?: string) => ['clash-of-teams', uid, 'dashboard'],
    clash_of_teams_rosters:   (uid?: string) => ['clash-of-teams', uid, 'rosters'],

    clubs__all:  () => ['clubs'],
    clubs:       (filter?: any) => ['clubs', filter],
    club:        (uid?: string) => ['clubs', uid],
    club_groups:       (club_uid?: string) => ['club-groups', club_uid],
    club_live_view:    () => ['club-live-view'],
    club_group:        (group_uid?: string) => ['club-groups', 'find', group_uid],
    club_subscription: (club_uid?: string) => ['club-subscription', club_uid],
    // The billing page's club profile. Its OWN key on purpose: it used to share
    // queryKeys.profile(uid) with the community/player profile pages, whose queryFns return
    // DIFFERENT shapes ({community: …} / player) under the same uid — so arriving at billing from
    // the community profile served that page's cache, `data.club` was undefined, and the billing
    // screen showed "couldn't load" on every first visit until Try again refetched.
    club_billing_profile: (club_uid?: string) => ['club-billing-profile', club_uid],
    communities:       (filter?: any) => ['communities', ...(filter ? [filter] : [])],
    community:         (uid?: string) => ['communities', uid],

    game:           (game_uid: string = '') => ['game', game_uid],
    upcoming_games: () => ['upcoming_games'],
    messages:       () => ['messages'],

    subscriptions:      () => ['subscription'],
    subscriptions_find: (subscription_id: number) => ['subscription', subscription_id],

    users: (filters?: any) => ['users', ...(filters ? [filters] : [])],
    user:  (user_uid: string | any) => ['users', user_uid],

    pricing_plans: (user_uid: string | any) => ['pricing-plans', user_uid],

    league_of_leagues:  (filters?: any) => ['league-of-leagues', ...(filters ? [filters] : [])],
    player_leaderboard: (filters?: any) => ['player-leaderboard', ...(filters ? [filters] : [])],
    organizer_leaderboard: (filters?: any) => ['organizer-leaderboard', ...(filters ? [filters] : [])],
    club_leaderboard:   (filters?: any) => ['club-leaderboard', ...(filters ? [filters] : [])],

    coins_stats:       () => ['coins_stats'],
    coins_redemptions: () => ['coins_redemptions'],
    player_coin_signal:    () => ['player_coin_signal'],
    organizer_lol_signal:  () => ['organizer_lol_signal'],

    referral_stats: (user_uid: string | any) => ['referral_stats', user_uid],
    referrals:      (user_uid?: string | any) => ['referrals', ...(user_uid ? [user_uid] : [])],

    wallet: (user_uid: string | any) => ['wallet', user_uid],
}

export default queryKeys;
